export default __webpack_public_path__ + "static/media/7-Brid Spa-24.39b73b9d.jpg";